import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import { FieldContainerDirective } from 'src/app/general/directives/field/field-container.directive';
import { FieldDirective } from 'src/app/general/directives/field/field.directive';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { DateAdapter, MAT_DATE_FORMATS, MAT_NATIVE_DATE_FORMATS, NativeDateAdapter } from '@angular/material/core';
import { MatCheckboxModule } from '@angular/material/checkbox';

// ----------------------------------------------------------------------------
// Usage Example

// Template:

// TS:

// public getReprocessOrderPaymentData(): void {
//   this.reprocessOrderPaymentDialogService.openDialog(
//     /* onUpdate */ outputDialogData => {
//       console.log(outputDialogData);
//     }
//   );
// }

// ----------------------------------------------------------------------------

export interface ReprocessOrderPaymentDialogData {
  reason?: string,
  sendToBusinessForPreparation?: boolean
}

@Component({
  selector: 'app-reprocess-order-payment-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatCheckboxModule,
    MatInputModule,
    FormsModule,
    TranslateModule,
    FieldContainerDirective,
    FieldDirective,
    MatDatepickerModule,
  ],
  // These providers are needed because this is a dialog component: https://github.com/angular/components/issues/28186
  // For regular components see example in https://material.angular.io/components/datepicker/overview
  providers: [ {provide: DateAdapter, useClass: NativeDateAdapter}, {provide: MAT_DATE_FORMATS, useValue: MAT_NATIVE_DATE_FORMATS} ],
  templateUrl: './reprocess-order-payment-dialog.component.html',
  styleUrls: ['./reprocess-order-payment-dialog.component.css']
})
export class ReprocessOrderPaymentDialogComponent {

  constructor(
      public dialogRef: MatDialogRef<ReprocessOrderPaymentDialogComponent>,
      @Inject(MAT_DIALOG_DATA) public data: ReprocessOrderPaymentDialogData) {
    // Default value
    data.sendToBusinessForPreparation = false;
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  public isValidDialogData(): boolean {
    return true;
  }
}
